
import { mapGetters } from 'vuex';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.ProductBuyButton',
  name: 'ProductBuyButton',
  props: {
    productName: {
      type: String,
      required: true
    },
    productUrl: {
      type: String,
      required: true
    },
    productImageUrl: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('widget', ['isPcViewport'])
  }
};
